let viewer;
let optionValues;
let materialNames;
var materialChangeStatus = {};

const optionOrder = {
  "Wood Finish": 0,
  "Metal Finish": 1,
  "Column": 2,
  "Column Finish": 3,
  "Fabric": 5,
  "Metal": 4,
};

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getFileNameFromUrl(url) {
  let urlObj = new URL(url);

  let pathname = urlObj.pathname;

  let imageName = pathname.split("/").pop();

  imageName = imageName.split("?")[0];
  imageName = imageName.split("#")[0];

  return imageName;
}

function checkIfMaterialsAllChanged() {
  let allowMaterialChange = true;

  if (Object.keys(materialChangeStatus).length > 0) {
    for (let key in materialChangeStatus) {
      if (!materialChangeStatus[key]) {
        allowMaterialChange = false;
      }
    }
  }

  return allowMaterialChange;
}

function sortOptionOrder(option1, option2) {
  let sort1 = 999;

  if (optionOrder.hasOwnProperty(option1.name)) {
    sort1 = optionOrder[option1.name];
  }

  let sort2 = 999;

  if (optionOrder.hasOwnProperty(option2.name)) {
    sort2 = optionOrder[option2.name];
  }

  if (sort1 > sort2) {
    return 1;
  } else {
    return -1;
  }
}

function takeScreenShot() {
  var productId = $('input[name="product-id"]').val();

  setTimeout(function () {
    viewer.takeScreenShotBase64().then((result) => {
      console.log(result);

      if (result) {
        localStorage.setItem("cart_img_base64_" + productId, result);
      }
    });
  }, 1600);
}

function getOpitons(components) {
  let options = [];

  for (var i = 0; i < components.length; i++) {
    const component = components[i];

    var materials = [];

    let materials_data = components[i]["materials"];

    console.log(materials_data);

    for (var j = 0; j < materials_data.length; j++) {
      const material_data = materials_data[j];

      if (
        material_data.thumbnail != "" &&
        material_data.name != "Default" &&
        typeof material_data.name !== "undefined"
      ) {
        let imageFile = getFileNameFromUrl(material_data.thumbnail);
        console.debug(imageFile);
        let zoomIn = "https://img.chromcrafthome.com/" + imageFile;

        const material = {
          name: material_data.name,
          materialId: material_data.id,
          thumbnail:
            material_data.thumbnail + "?x-oss-process=image/resize,m_fill,w_64",
          zoomin:
            material_data.thumbnail +
            "?x-oss-process=image/resize,m_fill,w_512", //zoomIn
        };

        materials.push(material);
      }
    }

    materials.sort((a, b) => {
      const aNumber = Number(a.name);
      const bNumber = Number(b.name);

      if (aNumber > bNumber) {
        return 1;
      } else if (aNumber < bNumber) {
        return -1;
      } else {
        return 0;
      }
    });

    const option = {
      name: component.name,
      materials: materials,
      componentIdStr: component.componentIds.join(","),
    };

    options.push(option);
  }

  options.sort(sortOptionOrder);

  return options;
}

function buildPanel(options) {
  let html = "";

  html += "<div class='cohoom-panel-content'>";

  options.forEach(function (option) {
    const materials = option.materials;

    html += "<div class='cohoom-option'>";
    html +=
      "<div class='cohoom-option-name'><span>" +
      option.name +
      "</span><i class='fa-solid fa-circle-check'></i></div>";

    html += "<div class='cohoom-option-content'>";

    materials.forEach(function (material) {
      if (!material.name.includes("默认") && material.name != material.materialId) {  //if (!material.name.includes("默认")) {
        html +=
          "<div class='cohoom-block' data-material-zoomin='" +
          material.zoomin +
          "' data-option-name='" +
          option.name +
          "' data-component-id-str='" +
          option.componentIdStr +
          "' data-material-id='" +
          material.materialId +
          "'>";
        html +=
          "<img class='cohoom-material-thumbnail' src='" +
          material.thumbnail +
          "'/>";
        html += "<div class='cohoom-material-name'>" + material.name + "</div>";
        html += "</div>";
      }
    });

    html += "</div>";
    html += "</div>";
  });

  html += "</div>";

  html += "<div class='cohoom-panel-clear' onclick='hidePanel()'></div>";

  $("#cohoom-panel").append(html);
}

function buildMaterialNames(options) {
  let materialNames = {};

  for (var i = 0; i < options.length; i++) {
    let materials = options[i]["materials"];

    for (var j = 0; j < materials.length; j++) {
      const material = materials[j];
      materialNames[material.materialId] = material.name;
    }
  }

  return materialNames;
}

function buildOptionValues(opitons) {
  let optionValues = {};

  opitons.forEach(function (opiton) {
    optionValues[opiton.name] = null;
  });

  return optionValues;
}

function generateOptionDescription() {
  let description = "";

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = optionValues[key];

    description += key + ": " + materialNames[value];

    if (i < keys.length - 1) {
      description += ", ";
    }
  }

  return description;
}

function validateOptionSelect() {
  let validated = true;

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (optionValues[key] == null) {
      validated = false;
      break;
    }
  }

  return validated;
}

function validateAddCart() {
  let validated = true;

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (optionValues[key] == null) {
      validated = false;
      break;
    }
  }

  if (validated) {
    $(".cart-btn-cover").remove();
    $('button[name="add"]').prop("disabled", false);
    $("#show-sticky-product").prop("disabled", false);
  }
}

// Resolves the Coohom SDK camera-controls object from the public viewer.
// In v1.1.17 the controls (getCameraInfo/setCamera) live on
// scene.getCameraControls(), reached via modelViewer.app.scene — but the SDK
// uses a few internal aliases for that scene, so we try each known path and
// return the first that actually exposes the camera API. Returns null if none
// match (e.g. a future SDK reshuffle), so callers degrade gracefully.
function getCohoomCameraControls(viewer) {
  if (!viewer) return null;

  const scenes = [
    viewer.modelViewer && viewer.modelViewer.app && viewer.modelViewer.app.scene,
    viewer.sdk &&
      viewer.sdk.modelViewer &&
      viewer.sdk.modelViewer.app &&
      viewer.sdk.modelViewer.app.scene,
    viewer.api && viewer.api.app && viewer.api.app.scene,
    viewer.app && viewer.app.scene,
    viewer.scene,
  ];

  for (const scene of scenes) {
    if (!scene || typeof scene.getCameraControls !== "function") continue;
    let controls;
    try {
      controls = scene.getCameraControls();
    } catch (e) {
      continue;
    }
    if (
      controls &&
      typeof controls.getCameraInfo === "function" &&
      typeof controls.setCamera === "function"
    ) {
      return controls;
    }
  }

  return null;
}

// Toggles the viewer's auto-rotate. The public viewer exposes setAutoRotate()
// (which drives the internal "camera-view" plugin); older/other builds only
// expose the requestStop/requestAutoRotate helpers or a plain property, so we
// fall back through those. No-ops safely if none are present.
function setCohoomAutoRotate(viewer, on) {
  try {
    if (typeof viewer.setAutoRotate === "function") {
      viewer.setAutoRotate(on);
    } else if (on && typeof viewer.requestAutoRotate === "function") {
      viewer.requestAutoRotate();
    } else if (!on && typeof viewer.requestStopAutoRotate === "function") {
      viewer.requestStopAutoRotate();
    } else {
      viewer.autoRotate = on;
    }
  } catch (e) {}
}

// Plays a one-time "dolly-in" on initial load: the camera starts farther away
// and eases in to the SDK's standard framing distance. Fully defensive — if the
// viewer's camera API isn't shaped as expected, it silently skips and the viewer
// renders normally at the standard distance.
function playIntroCameraAnimation(viewer) {
  try {
    const controls = getCohoomCameraControls(viewer);
    if (!controls) {
      return;
    }

    // Respect users who prefer reduced motion — leave the camera at standard.
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }

    const standard = controls.getCameraInfo();
    if (
      !standard ||
      !Array.isArray(standard.position) ||
      !Array.isArray(standard.lookAt)
    ) {
      return;
    }

    const lookAt = standard.lookAt;
    const endPos = standard.position;
    const fov = standard.fov;

    // Offset vector from the look-at target to the standard camera position.
    const dx = endPos[0] - lookAt[0];
    const dy = endPos[1] - lookAt[1];
    const dz = endPos[2] - lookAt[2];

    // Start this many times farther out than the standard distance, then ease in.
    const START_SCALE = 2.4;
    const startPos = [
      lookAt[0] + dx * START_SCALE,
      lookAt[1] + dy * START_SCALE,
      lookAt[2] + dz * START_SCALE,
    ];

    // Suspend auto-rotate so it doesn't fight the dolly-in. Auto-rotate rewrites
    // the full camera every tick from a fixed-radius snapshot, so it must be off
    // during the zoom; it's restored (and re-snapshots the standard radius) after.
    const resumeAutoRotate =
      typeof viewer.getAutoRotate === "function"
        ? viewer.getAutoRotate()
        : true; // constructed with autoRotate:true in loadCohoomView
    setCohoomAutoRotate(viewer, false);

    // Snap to the far start position before the first painted frame.
    controls.setCamera({ position: startPos, lookAt: lookAt, fov: fov });

    const DURATION = 1600; // ms
    const startTime = performance.now();
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    function frame(now) {
      let t = (now - startTime) / DURATION;
      if (t > 1) t = 1;
      const e = easeOutCubic(t);

      const pos = [
        startPos[0] + (endPos[0] - startPos[0]) * e,
        startPos[1] + (endPos[1] - startPos[1]) * e,
        startPos[2] + (endPos[2] - startPos[2]) * e,
      ];

      controls.setCamera({ position: pos, lookAt: lookAt, fov: fov });

      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        // Land exactly on the standard camera, then resume auto-rotate.
        controls.setCamera({ position: endPos, lookAt: lookAt, fov: fov });
        if (resumeAutoRotate) {
          setCohoomAutoRotate(viewer, true);
        }
      }
    }

    requestAnimationFrame(frame);
  } catch (err) {
    console.warn("Intro camera animation skipped:", err);
  }
}

// Quaternion helpers ([x,y,z,w]) for composing world-axis rotations onto the
// module's original orientation.
function cohoomAxisAngle(ax, ay, az, ang) {
  const s = Math.sin(ang / 2);
  return [ax * s, ay * s, az * s, Math.cos(ang / 2)];
}
function cohoomQuatMul(a, b) {
  const [ax, ay, az, aw] = a;
  const [bx, by, bz, bw] = b;
  return [
    aw * bx + ax * bw + ay * bz - az * by,
    aw * by - ax * bz + ay * bw + az * bx,
    aw * bz + ax * by - ay * bx + az * bw,
    aw * bw - ax * bx - ay * by - az * bz,
  ];
}

// Adds a button (only for compound / kpxGroup models) that hops a random module
// "section": it rises above its neighbours' bounding boxes so it never clips
// them, swoops sideways in an eased arc while spinning, tilts as it climbs/falls
// and banks into the arc, then lands back on its exact original transform.
function setupModularSectionButton(viewer) {
  try {
    const app =
      (viewer.modelViewer && viewer.modelViewer.app) ||
      (viewer.api && viewer.api.app);
    const scene = app && app.scene;
    if (!scene || typeof scene.getActorsByTag !== "function") return;

    const host =
      document.querySelector(".cohoom-model-wrap") ||
      document.querySelector(".cohoom-wrap");
    if (!host) return;
    // Don't add a second button if afterDidMount runs again.
    if (host.querySelector(".cohoom-animate-section-btn")) return;

    // ---- tunables ----
    const SPIN_TURNS = 1;
    const ARC = 320; // sideways swoop distance (world units)
    const CLEARANCE = 120; // gap kept above the tallest neighbour
    const TILT_DEG = 15; // nose-down/back pitch
    const LEAN_DEG = 12; // bank/roll into the arc
    const T_UP = 650,
      T_HOVER = 2000,
      T_DOWN = 650;

    const getActors = () => scene.getActorsByTag("model") || [];
    const easeInOut = (t) =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const setAuto = (on) => {
      try {
        if (typeof viewer.setAutoRotate === "function") viewer.setAutoRotate(on);
        else if (!on && viewer.requestStopAutoRotate)
          viewer.requestStopAutoRotate();
        else if (on && viewer.requestAutoRotate) viewer.requestAutoRotate();
      } catch (e) {}
    };

    let lastIdx = -1;
    let running = false;

    const runAnim = () =>
      new Promise((resolve) => {
        const actors = getActors();
        if (!actors.length) return resolve();

        let idx = Math.floor(Math.random() * actors.length);
        if (actors.length > 1 && idx === lastIdx)
          idx = (idx + 1) % actors.length;
        lastIdx = idx;
        const a = actors[idx];

        const p0 = Array.from(a.getPosition());
        const q0 = Array.from(a.getRotation()); // [x,y,z,w]
        const mb = a.getWorldBoundingBox();
        const movBottom = mb.min[2];
        const movCenterY = (mb.min[1] + mb.max[1]) / 2;

        // Clearance derived from the stationary modules' bounding boxes.
        let topMax = -Infinity,
          cSum = 0,
          cN = 0;
        actors.forEach((o, i) => {
          if (i === idx) return;
          const b = o.getWorldBoundingBox();
          topMax = Math.max(topMax, b.max[2]);
          cSum += (b.min[1] + b.max[1]) / 2;
          cN++;
        });
        const LIFT = Math.max(300, topMax - movBottom + CLEARANCE);
        let arcDir = cN ? Math.sign(cSum / cN - movCenterY) : 1;
        if (!arcDir) arcDir = Math.random() < 0.5 ? 1 : -1;

        const TILT = (TILT_DEG * Math.PI) / 180;
        const LEAN = (LEAN_DEG * Math.PI) / 180;
        const full = 2 * Math.PI * SPIN_TURNS;
        const total = T_UP + T_HOVER + T_DOWN;
        const redraw = () => {
          app.needDraw = true;
        };

        const apply = (z, dy, spin, tilt, lean) => {
          // world-frame: lean(Y) * tilt(X) * spin(Z) * original
          let q = cohoomQuatMul(cohoomAxisAngle(0, 0, 1, spin), q0);
          q = cohoomQuatMul(cohoomAxisAngle(1, 0, 0, tilt), q);
          q = cohoomQuatMul(cohoomAxisAngle(0, 1, 0, lean), q);
          a.setPosition(p0[0], p0[1] + dy, p0[2] + z);
          a.setRotation(q[0], q[1], q[2], q[3]);
        };

        const wasAuto =
          typeof viewer.getAutoRotate === "function"
            ? viewer.getAutoRotate()
            : true;
        setAuto(false);

        const t0 = performance.now();
        const step = (now) => {
          const te = Math.min(now - t0, total);
          let z, dy, spin, tilt, lean;
          if (te < T_UP) {
            const p = easeInOut(te / T_UP);
            z = LIFT * p;
            dy = 0;
            spin = 0;
            tilt = -TILT * Math.sin(Math.PI * p);
            lean = 0;
          } else if (te < T_UP + T_HOVER) {
            const p = easeInOut((te - T_UP) / T_HOVER);
            z = LIFT;
            dy = ARC * arcDir * Math.sin(Math.PI * p);
            spin = full * p;
            tilt = 0;
            lean = LEAN * arcDir * Math.sin(Math.PI * p);
          } else {
            const p = easeInOut((te - T_UP - T_HOVER) / T_DOWN);
            z = LIFT * (1 - p);
            dy = 0;
            spin = full;
            tilt = TILT * Math.sin(Math.PI * p);
            lean = 0;
          }
          apply(z, dy, spin, tilt, lean);
          redraw();
          if (te < total) {
            requestAnimationFrame(step);
          } else {
            // Snap back to the exact original transform.
            a.setPosition(p0[0], p0[1], p0[2]);
            a.setRotation(q0[0], q0[1], q0[2], q0[3]);
            redraw();
            if (wasAuto) setAuto(true);
            resolve();
          }
        };
        requestAnimationFrame(step);
      });

    const btn = document.createElement("button");
    btn.type = "button"; // never submit the product form
    btn.className = "cohoom-animate-section-btn";
    btn.textContent = "Animate section";
    btn.style.cssText = [
      "position:absolute",
      "left:50%",
      "bottom:18px",
      "transform:translateX(-50%)",
      "z-index:50",
      "padding:10px 18px",
      "border:0",
      "border-radius:24px",
      "cursor:pointer",
      "font:600 14px/1 system-ui,sans-serif",
      "color:#fff",
      "background:#033c5a",
      "box-shadow:0 2px 10px rgba(0,0,0,.25)",
    ].join(";");
    btn.addEventListener("click", async () => {
      if (running) return;
      running = true;
      btn.disabled = true;
      btn.style.opacity = "0.6";
      btn.style.cursor = "default";
      try {
        await runAnim();
      } finally {
        running = false;
        btn.disabled = false;
        btn.style.opacity = "1";
        btn.style.cursor = "pointer";
      }
    });

    if (getComputedStyle(host).position === "static") {
      host.style.position = "relative";
    }
    host.appendChild(btn);
  } catch (err) {
    console.warn("Modular section button skipped:", err);
  }
}

function loadCohoomView(modelId) {
  let variantId = window.location.search.split('variant=')[1];
  const idKey = (modelId && modelId.length === 12) ? 'modelId' : 'kpxGroupId';
  if (modelId.length < 2){
    $(".cohoom-wrap").remove();
  }
  else {
  viewer = new koolViewer.ViewerUISDK({
    mount: document.getElementById("cohoom-model"),
    apiSource: 'prod',
    [idKey]: modelId,
    autoRotate: true,
    useCoohomAPI: false,
    useCoohomCDN: true,
    enablePanel: false,
    enableOperationPanel: true,
    textureSize: 512,
    textureQuality: 50,
    lengthUnit: 'in',
    locale: 'en_US',
    enableWireFrame: false,
    enableArIcon: false,
    enableShareIcon: false,
    showRuler: false,    
    async afterDidMount() {
      let componentsObj = {};

      const componentsData = viewer.getComponents();

      componentsData.forEach(function (component) {
        const key = component.name;

        if (typeof componentsObj[key] === "undefined") {
          componentsObj[key] = {
            name: component.name,
            materials: component.materials,
            componentIds: [],
          };
        }

        componentsObj[key].componentIds.push(component.id);
      });

      let components = [];

      Object.keys(componentsObj).forEach((key) => {
        components.push(componentsObj[key]);
      });

      const options = getOpitons(components);

      buildPanel(options);

      optionValues = buildOptionValues(options);
      materialNames = buildMaterialNames(options);

      $(".skeleton-content").remove();
      $("#cohoom-model-skeleton").remove();

      // Ease the camera in from a distance on initial load. Give the SDK a beat
      // to finish auto-framing the model so we capture the true standard camera.
      setTimeout(function () {
        playIntroCameraAnimation(viewer);
      }, 60);

      // Compound (kpxGroup) models load as several independent module sections;
      // only those get the "Animate section" button. Single models skip it.
      if (idKey === "kpxGroupId") {
        setupModularSectionButton(viewer);
      }

/*       $(".cohoom-model-wrap").append(
        '<img class="cohoom-usa" src="https://cdn.shopify.com/s/files/1/0808/3193/8871/files/usa-v2.png">'
      ); */
    },
  });
}
}

function togglePanel() {
  let panel = $("#cohoom-panel");

  if (panel.hasClass("animate__fadeInLeft")) {
    panel.removeClass("animate__fadeInLeft");
    panel.addClass("animate__fadeOutLeft");
  } else {
    panel.removeClass("animate__fadeOutLeft");
    panel.addClass("animate__fadeInLeft");
    panel.show();
  }
}

function hidePanel() {
  let panel = $("#cohoom-panel");
  panel.removeClass("animate__fadeInLeft");
  panel.addClass("animate__fadeOutLeft");
}

$(document).on("click", ".cohoom-block", function () {
  if (checkIfMaterialsAllChanged()) {
    //add loading effect
    //html = '<div id="cohoom-model-skeleton">';
    //html += '<div class="skeleton-block"></div>';
    //html += '</div>';
    //$(".cohoom-model-wrap").append(html);

    //add material select effect
    $(this)
      .closest(".cohoom-option")
      .find(".fa-circle-check")
      .css("color", "#033c5a");
    $(this)
      .closest(".cohoom-option")
      .find(".cohoom-material-thumbnail")
      .removeClass("cohoom-material-thumbnail-selected");
    $(this)
      .find(".cohoom-material-thumbnail")
      .addClass("cohoom-material-thumbnail-selected");

    //get data
    const optionName = $(this).attr("data-option-name");
    const materialId = $(this).attr("data-material-id");
    const zoomin = $(this).attr("data-material-zoomin");
    const componentIdStr = $(this).attr("data-component-id-str");

    //change mateirals
    materialChangeStatus = {};
    let isMaterialChangeInProgress = false;
    const componentIds = componentIdStr.split(",");

    for (componentId of componentIds) {
      materialChangeStatus[componentId] = false;
    }

    //for (componentId of componentIds) {
    //  if (!isMaterialChangeInProgress) { // Check if a change is already in progress
    //    isMaterialChangeInProgress = true; // Set to true to block new changes
    //    viewer.changeMaterial(componentId, materialId).promise.then(() => {
    //      $('#cohoom-model-skeleton').remove();
    //      materialChangeStatus[componentId] = true;
    //      isMaterialChangeInProgress = false; // Reset the flag after completion
    //    }).catch((error) => {
    //      // Handle the error, especially the abort event
    //      if (error.type === 'abort') {
    //        console.warn('Request was aborted:', error);
    //        console.warn('Request was aborted:', componentId + " AND " + materialId);
    //        // Handle the abort specifically, e.g., provide user feedback or clean up
    //      } else {
    //        console.error('An unexpected error occurred:', error);
    //      }
    //      isMaterialChangeInProgress = false; // Ensure flag is reset on error
    //    });
    //  } else {
    //    console.warn('A material change is already in progress. Ignoring this request.');
    //  }
    //}

  



    
    async function processComponentIds(componentIds) {
      for (componentId of componentIds) {
        if (!isMaterialChangeInProgress) {
          isMaterialChangeInProgress = true;
          try {
            await viewer.changeMaterial(componentId, materialId).promise;
            $("#cohoom-model-skeleton").remove();
            materialChangeStatus[componentId] = true;
          } catch (error) {
            // Handle errors, including aborted requests
            if (error.type === "abort") {
              console.warn(
                "Request was aborted:",
                componentId + " , " + materialId
              );
            } else {
              console.error("An unexpected error occurred:", error);
            }
          } finally {
            isMaterialChangeInProgress = false;
          }
        } else {
          console.warn(
            "A material change is already in progress. Ignoring this request."
          );
        }
      }
    }

    // Usage:
    processComponentIds(componentIds).catch((error) => {
      // Handle any uncaught errors
    });
    //write option data
    optionValues[optionName] = materialId;
    const optionDescription = generateOptionDescription();
    $("#material").val(optionDescription);

    //validate cart
    validateAddCart();

    //store current view
    takeScreenShot();
  }
});

function handleBtnCoverClick() {
  $(".cohoom-alert-wrap").remove();

  let alertMessage = "Please select ";

  let notSelectedMaterials = [];

  Object.entries(optionValues).forEach(([key, value]) => {
    if (value == null) {
      notSelectedMaterials.push(key);
    }
  });

  alertMessage += notSelectedMaterials.join(", ");
  alertMessage += " in the material panel";

  let alertElement =
    '<div class="cohoom-alert-wrap animate__animated animate__fadeInDown animate__faster">';
  alertElement += '<div class="cohoom-alert-inner">' + alertMessage + "</div>";
  alertElement += "</div>";

  $("body").append(alertElement);

  setTimeout(function () {
    $(".cohoom-alert-wrap").removeClass("animate__fadeInDown");
    $(".cohoom-alert-wrap").addClass("animate__fadeOutUp");
  }, 3000);
}

$(document).ready(function () {
  
  $(document).on("mouseenter", ".cohoom-block", function () {
    if (window.innerWidth > 768) {
      const zoomin = $(this).attr("data-material-zoomin");

      $("#cohoom-material-zoomin").remove();
      let zoomInImage =
        '<div id="cohoom-material-zoomin" class="animate__animated animate__fadeIn" style="background-image: url(' +
        zoomin +
        ')"></div>';
      $(".cohoom-wrap").append(zoomInImage);
    }
  });

  $(document).on("mouseleave", ".cohoom-block", function () {
    $("#cohoom-material-zoomin").remove();
  });

  let cartButtonCover = $(
    '<div class="cart-btn-cover" onclick="handleBtnCoverClick()"><span></span></div>'
  );
  $(".product-form__buttons").append(cartButtonCover);

  let cartButtonCoverStick = $(
    '<div class="cart-btn-cover" onclick="handleBtnCoverClick()"><span></span></div>'
  );
  $(".empty-add-cart-button-wrapper").css("position", "relative");
  $(".empty-add-cart-button-wrapper").append(cartButtonCoverStick);

  $('button[name="add"]').prop("disabled", true);
  $("#show-sticky-product").prop("disabled", true);
});

